module.exports = __webpack_public_path__ + "static/media/dop-aapl.c32dfd7c.svg";